import React from 'react';
import useTrack from '../hooks/useTrack';
import AudioTrack from './AudioTrack';
import VideoTrack from './VideoTrack';
import DataTrack from './DataTrack';

export default function Publication({ publication, isLocal, disableAudio, videoPriority, className }) {
    const track = useTrack(publication);

    if (!track) return null;

    switch (track.kind) {
        case 'video':
            return <VideoTrack track={track} priority={videoPriority} isLocal={track.name.includes('camera') && isLocal} className={className} />;
        case 'audio':
            return disableAudio ? null : <AudioTrack track={track} />;
        case 'data':
            return disableAudio ? null : <DataTrack track={track} />;
        default:
            return null;
    }
}
